module.exports = __webpack_public_path__ + "img/favoritos-seleccionado.6e311d6a.png";